import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { withUtm } from "@/lib/utm";

export default function ClosingSection() {
  return (
    <section className="relative overflow-hidden" data-testid="closing-section">
      <img
        src="https://customer-assets-39nsmqrw.emergentagent.net/job_talent-hub-822/artifacts/im0eko3r_%D8%A7%D8%A8%D8%AF%D8%A1%20%D8%A7%D9%84%D8%A7%D9%86.jpeg"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-l from-slate-950/95 via-teal-950/90 to-teal-900/80" />
      <div className="relative max-w-6xl mx-auto px-6 lg:px-10 py-24 lg:py-32 z-10">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-widest text-amber-300 mb-4">ابدأ الآن</div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-black text-white leading-[1.1]">
            رحلتك المهنية قد تبدأ بفرصة التدريب التعاوني
          </h2>
          <p className="mt-6 text-lg text-teal-100 max-w-xl leading-relaxed">
            اختر فرصة تناسب مجالك، أو انضم كشريك ووسّع أثر منظمتك عبر عماد.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link
              to={withUtm("/opportunities")}
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-teal-900 font-bold hover:bg-amber-50 hover:-translate-y-0.5 focus-visible:ring-4 focus-visible:ring-white/30 transition-all"
              data-testid="closing-cta-opps"
            >
              استعرض الفرص <ArrowLeft className="h-5 w-5" />
            </Link>
            <Link
              to={withUtm("/partners")}
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-white/40 text-white font-semibold hover:bg-white/10 focus-visible:ring-4 focus-visible:ring-white/20 transition-all"
              data-testid="closing-cta-partner"
            >
              انضم لشركاء عماد
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
